<div class="customCheckbox" [ngClass]="customCBxwrapperClass" >
    <!-- <label class="customCheckboxContainer" [ngClass]="customCBxlabelClass">          
      <input type="checkbox" class="customCheckboxInput" [disabled]="customCBxDisabled" [checked]="customCBxChecked" [id]="customCBxId"  (change)="customCheckboxChange($event)">
      <span class="checkbox-material"><span class="check"></span></span>
    </label> -->
    <label class="custom-checkbox" [ngClass]="customCBxDisabled ? 'disableClass' : ''">
      <input class="checkbox-Class" type="checkbox" [disabled]="customCBxDisabled"  [checked]="customCBxChecked" value="checkbox1" [id]="customCBxId"  (change)="customCheckboxChange($event)">
      <span></span>
    </label>
  </div> 
  
 
 
  